import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { SupportTicketDemoData } from '../../../data';
import { useTemplate } from '../../features/template/TemplateProvider';
import { ApiLoadSupportTickets } from './SupportTicketOperation';

const SupportTicketContext = createContext();

export const useSupportTicket = () => useContext(SupportTicketContext);

function SupportTicketProvider({ children }) {
    const [params, setParams] = useState({});
    // --Data reload
    const [reloadKey, setReloadKey] = useState(0);
    // --Store initial data
    const [supportTicketData, setSupportTicketData] = useState(SupportTicketDemoData);
    // --Modal open handler
    const [showModal, setShowModal] = useState({
        type: '',
        data: null
    });

    const { setMessage } = useTemplate();

    // -- Load all customer initially
    useEffect(() => {
        setSupportTicketData({ supportTickets: SupportTicketDemoData, pagination: {} });
        if (Object.keys(params).length > 0) {
            ApiLoadSupportTickets(params)
                .then(({ data }) => {
                    setSupportTicketData(data);
                })
                .catch((err) => {
                    setSupportTicketData({ supportTickets: [], pagination: {} });
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        }
    }, [setMessage, reloadKey, params]);

    const value = useMemo(() => {
        // -- Reload Button
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            // setSupportTicketData(SupportTicketDemoData);
        };

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };
        return {
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,

            // Support Ticket Data
            supportTicketData,
            setSupportTicketData,

            // -- Reload
            reloadKey,
            setReloadKey,
            handleReload,
            params,
            setParams
        };
    }, [showModal.type, showModal.data, supportTicketData, reloadKey, params]);

    return <SupportTicketContext.Provider value={value}>{children}</SupportTicketContext.Provider>;
}

export default SupportTicketProvider;
